import { Box, CssBaseline } from '@mui/material';
import ThemeProvider from '../components/ThemeProvider';
import { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useCookiesLogin } from '../config/cookies';
import Topbar from '../scenes/global/Topbar';
import { ColorModeContext, useMode } from '../theme';
import SidebarManager from './helpers/SidebarManager';
import { AccessStageProvider } from '../context/AccessStageContext';

function Template() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const { cookies } = useCookiesLogin();
  const navigate = useNavigate();

  useEffect(() => {
    if (cookies.AUTH_TOKEN === undefined) {
      navigate('/');
    }
  }, []);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AccessStageProvider>
          <div className="app">
            <SidebarManager access={cookies.AUTH_TOKEN?.role} isSidebar={isSidebar} />

            <main className="content overflow-y-auto" style={{ backgroundColor: '#EEF0F3' }}>
              <Topbar setIsSidebar={setIsSidebar} />
              <Box sx={{ height: '90vh', overflowY: 'scroll' }}>
                <Outlet />
              </Box>
            </main>
          </div>
        </AccessStageProvider>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default Template;
